<div class="background">
  <div class="login-block">
    <div class="header">
      <div class="back-button"></div>
    </div>
    <div class="desc-text">Войдите в свой аккаунт, под которым регистрировались в DexBee</div>
    <div class="button-block">
      @if (isAgreementChecked) {
      @if (appConfig.vkAllowed) {
      <div class="button first" (click)="signInWithVK()">
        <div class="vk"></div>
      </div>
      }
      @if (appConfig.emailAllowed) {
      <div class="button" (click)="signInWithEmail()">
        <div class="email"></div>
      </div>
      }
      @if (appConfig.googleAllowed) {
      <div class="button" (click)="signInWithGoogle()">
        <div class="google"></div>
      </div>
      }
      @if (appConfig.appleAllowed) {
      <div class="button" (click)="signInWithApple()">
        <div class="apple"></div>
      </div>
      }
      }
      @else {
      @if (appConfig.vkAllowed) {
      <div class="button disabled first">
        <div class="vk"></div>
      </div>
      }
      @if (appConfig.emailAllowed) {
      <div class="button disabled">
        <div class="email"></div>
      </div>
      }
      @if (appConfig.googleAllowed) {
      <div class="button disabled">
        <div class="google"></div>
      </div>
      }
      @if (appConfig.appleAllowed) {
      <div class="button disabled">
        <div class="apple"></div>
      </div>
      }
      }
    </div>
    <div class="condition">
      <input type="checkbox" class="checkbox" [(ngModel)]="isAgreementChecked" name="agreementCB"
        (change)="onAgreementChange()">
      <p class="condition-text">Согласен с <a href="https://dexbee.ru/privacy_policy"> политикой обработки
          персональных данных</a>
      </p>
    </div>
  </div>
</div>